import { observer } from 'mobx-react'
import React from 'react'

import {
   GetEntityJsonConfigurationDocument,
   UserPermittedTemplateAccessOverrideConfig
} from '@flowwai-frontend/bps-officer-web/common/data-access'
import { JsonConfigurationEntityType } from '@flowwai-frontend/bps-officer-web/graphql'
import {
   useIsDashboardAdmin,
   useUserAppConfigStore
} from '@flowwai-frontend/bps-officer-web/iam'
import {
   UnionNavItemModel,
   useNavbarStore
} from '@flowwai-frontend/bps-officer-web/navbar-base'
import { useApolloClientWithAuth } from '@flowwai-frontend/shared/auth/common'
import { EMPTY_STRING } from '@flowwai-frontend/shared/constants'

import NavbarTemplatesSection from '../../components/NavbarTemplatesSection/NavbarTemplatesSection'

const TemplatesSectionNavItemController = (): React.ReactElement | null => {
   const navbarStore = useNavbarStore()
   const isDashboardAdmin = useIsDashboardAdmin()
   const { userId } = useUserAppConfigStore()

   const client = useApolloClientWithAuth()

   // Hide templates section for dashboard admin users
   if (isDashboardAdmin) {
      return null
   }

   const getTemplateNavItems = (): UnionNavItemModel[] | undefined => {
      try {
         const entityJsonConfigResponse = client.readQuery({
            query: GetEntityJsonConfigurationDocument,
            variables: {
               params: {
                  entityType:
                     JsonConfigurationEntityType.PipelineItemTemplateAccessOverrideConfig
               }
            }
         })

         const mappingData = JSON.parse(
            entityJsonConfigResponse?.getEntityJsonConfiguration
               ?.jsonConfiguration?.jsonData || ''
         ) as UserPermittedTemplateAccessOverrideConfig | null

         const currentUserIdTemplatesConfig =
            mappingData?.user_permitted_pipeline_item_templates_map?.[
               userId ?? EMPTY_STRING
            ]

         const hasTemplatesConfigForUser = currentUserIdTemplatesConfig?.length

         const updatedTemplateNavItems = hasTemplatesConfigForUser
            ? navbarStore.templatesNavItem?.items?.filter(eachItem =>
                 currentUserIdTemplatesConfig.includes(eachItem.id)
              )
            : navbarStore.templatesNavItem?.items

         return updatedTemplateNavItems
      } catch (error) {
         return navbarStore.templatesNavItem?.items
      }
   }

   const updatedTemplateNavItems = getTemplateNavItems()

   const hasTemplateNavItems = !!updatedTemplateNavItems?.length

   return hasTemplateNavItems ? (
      <>
         <NavbarTemplatesSection templateNavItems={updatedTemplateNavItems} />
         <hr className='my-[8px]' />
      </>
   ) : null
}

export default observer(TemplatesSectionNavItemController)
